
import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { MyProfileActions } from '../actions/index';
import { MyProfilePage } from '../my-profile-state';
import { ApiService } from '../../../../SGRE-shared/services/api.service';
import { GlobalService } from '../../../../SGRE-shared/services/global.service';
import { MyProfileEffectsService } from './my-profile-effects.service';
import { LoggerService, tryNormalizeHttpError } from '@spartacus/core';

@Injectable()

export class MyProfileEffects {

  constructor(
    private actions$: Actions,
    private readonly apiService: ApiService,
    private globalService: GlobalService,
    private myProfileEffectsService: MyProfileEffectsService
  ) { }

  protected logger = inject(LoggerService);

  FetchMyProfile$: Observable<
    ReturnType<typeof MyProfileActions.fetchMyProfileSuccess> |
    ReturnType<typeof MyProfileActions.fetchMyProfileFail>
  > = createEffect(() =>
    this.actions$.pipe(
      ofType(MyProfileActions.fetchMyProfile),
      switchMap((action) => this.apiService.getProfileList(action.queryText)),
      map((data: MyProfilePage) => {
        this.globalService.loadingSubject.next(false);
        return MyProfileActions.fetchMyProfileSuccess({ results: this.myProfileEffectsService.formatMyProfileData(data) });
      }),
      catchError((error) =>
        of(MyProfileActions.fetchMyProfileFail({ payload: tryNormalizeHttpError(error, this.logger) }))
      )
    )
  );

}